/**
 * H5 大屏统一静态资源（全部已上传阿里云 OSS）。
 * 新增资源只在这里追加，页面不要再写死外链。
 */

export const OSS_ASSET_BASE =
  'https://oss-pai-s2lxmtw6mbk6ofo9ye-cn-shanghai.oss-cn-shanghai.aliyuncs.com/upload/party/assets'

export function ossUrl(path) {
  const p = String(path || '').replace(/^\/+/, '')
  return p ? OSS_ASSET_BASE + '/' + p : ''
}

const RES = 'res.sessionhd.newstartjx.com/yjhdv3/'
const STATIC = 'static.newstartjx.com/'
const HUDONG = STATIC + 'static/yjhdv2/client/image/hudongs/'
const SKIN = STATIC + 'static/skin/yearox/'

/** 玩法图标 */
export const PARTY_GAME_ICONS = {
  year_end: ossUrl(HUDONG + 'welcome.png'),
  lottery: ossUrl(HUDONG + 'listdraw.png'),
  rolling_avatar: ossUrl(SKIN + 'group_classics.png'),
  open_box: ossUrl(HUDONG + 'grab_packet.png'),
  money: ossUrl(SKIN + 'money.png'),
  tap_race: ossUrl(HUDONG + 'three.png'),
  sound_wave: ossUrl(HUDONG + 'voice.png'),
  barrage: ossUrl(HUDONG + 'barrage.png'),
  vote: ossUrl(HUDONG + 'vote.png')
}

/** 奖品占位图（无图时兜底） */
export const PARTY_PRIZE_FALLBACK = ossUrl(HUDONG + 'grab_packet.png')

/** 默认头像：用户未提供头像时使用（与后端 PartyJoin 兜底保持一致） */
export const PARTY_DEFAULT_AVATAR = PARTY_GAME_ICONS.year_end

/** 大屏背景视频 */
export const PARTY_BG_VIDEO_PRESETS = [
  { key: 'vid_gold', label: '金色粒子', url: ossUrl(RES + '20251125/77a8049394ca4fc4a87d3380bcddfc79.mp4') },
  { key: 'vid_red', label: '红色光效', url: ossUrl(RES + '20251125/bfc8419b904b47b4a8c0574ed50f4046.mp4') },
  { key: 'vid_blue', label: '蓝色科技', url: ossUrl(RES + '20251125/cc3fd0c1ce66434691af55ccc22aa297.mp4') },
  { key: 'vid_neon', label: '霓虹流光', url: ossUrl(RES + '20211022/346654259f714636970c530b178ed58b.mp4') },
  { key: 'vid_wave', label: '光影波动', url: ossUrl(RES + '20211230/2520f0c193be41a8802f23f86741a911.mp4') },
  { key: 'vid_dark', label: '暗夜星尘', url: ossUrl(RES + '20221214/3bfdd4c259314427bcf969e63ed5d2b6.mp4') }
]
